import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * ServiceLocator
 *
 * @hidden
 * @deprecated
 */
export class ServiceLocator {
    constructor() {
        this.services = {};
    }
    /* eslint-disable */
    /**
     * register method
     *
     * @param {string} name - specifies the name.
     * @param {T} type - specifies the type.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    /* eslint-enable */
    register(name, type) {
        if (isNullOrUndefined(this.services[`${name}`])) {
            this.services[`${name}`] = type;
        }
    }
    /**
     * getService method
     *
     * @param {string} name - specifies the name.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    getService(name) {
        if (isNullOrUndefined(this.services[`${name}`])) {
            // eslint-disable-next-line
            throw `The service ${name} is not registered`;
        }
        return this.services[`${name}`];
    }
    destroy() {
        this.services = {};
    }
}
